import echarts from "echarts/lib/echarts";
import { useContext } from "react";
import AppContext from "../../../context/Context";

export default function SikkaEchartTheme() {
  const { isDark } = useContext(AppContext);
  var config_pie = {
    darkMode: isDark,
    title: {
      textStyle: {
        color: isDark ? "#fff" : "#000",
      },
    },
    legend: {
      textStyle: {
        color: isDark ? "#fff" : "#000",
      },
    },
    graph: {
      color: isDark ? "#fff" : "#000",
    },
    categoryAxis: {
      axisLine: {
        lineStyle: {
          color: isDark ? "#fff" : "#000",
        },
      },
      textStyle: {
        color: isDark ? "#fff" : "#000",
      },
    },
    valueAxis: {
      axisLine: {
        lineStyle: {
          color: isDark ? "#fff" : "#000",
        },
      },
    },
    dataRange: {
      textStyle: {
        color: isDark ? "#fff" : "#000",
      },
    },
  };

  echarts.registerTheme("SikkaEchartTheme-Pie", config_pie);
  echarts.registerTheme("SikkaEchartTheme-Bar", { textStyle: { color: isDark ? "#fff" : "#000" }, ...config_pie });
}
